import React from 'react';
import { deleteCustomer } from '../../backend-services';
import { useNavigate } from 'react-router';
import { SidebarDrawer } from '../common';
import LeftNotificationPopup from '../core/NotificationPopup/LeftNotificationPopup';
import ProcessSuccessful from '../../assets/icons/ProcessSuccessful';


interface CustomereDeletePromptProps {
  showPrompt: boolean;
  show: any;
  onCustomerDelete?: (customer: any) => void;
  customerId: string;
  onClose?: () => void;
  onDeleteSuccess?: () => void;
}

const CustomerDeletePrompt = ({ showPrompt, show, customerId, onCustomerDelete, onClose, onDeleteSuccess }: CustomereDeletePromptProps) => {
  const [isDeleting, setIsDeleting] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState('');
  const [isDeleted, setIsDeleted] = React.useState(false);
  const [showSuccessSidebar, setShowSuccessSidebar] = React.useState(false);

  const navigate = useNavigate();

  const handleDeleteCustomer = async (id: string) => {
    setIsDeleting(true);
    try {
      const data = await deleteCustomer(id);
      setIsDeleting(false);
      setIsDeleted(true);
      onCustomerDelete && onCustomerDelete(id);
      onDeleteSuccess && onDeleteSuccess();
    } catch (error: any) {
      console.log(error);
      setErrorMessage('Unable to Delete Customer.');
      setIsDeleting(false);
      if (error.expense && (error.expense.status === 400 || error.expense.status === 500)) {
        navigate('/error');
      }
    }
  };

  const handleKeepCustomer = () => {
    onClose && onClose();
  };
  
  React.useEffect(() => {
    if (isDeleted) {
      setShowSuccessSidebar(true);
      setTimeout(() => {
        navigate('/customers');
      }, 3000); 
    }
  }, [isDeleted, navigate]);

  const closeSuccessSidebar = () => {
    setShowSuccessSidebar(false);
  };

  return (

      <>
        <div className="h-screen">
          <div className="flex justify-center mt-[13px] ">
            <h1>You are about to delete a customer ? This action cannot be  reversed once confirmed. </h1>
          </div>
          <div role="form" onSubmit={(e) => e.preventDefault()}>
            <div className="flex ml-[10px] pt-[79px] pb-[40px]">
              <button
                className="w-[239px] rounded-[4px] h-[55px] bg-[#FB0303] text-white font-semibold"
                onClick={() => handleDeleteCustomer(customerId)}
                disabled={isDeleting}
              >
                {isDeleting ? 'Deleting...' : 'Yes, Delete'}
              </button>
            </div>
            <div className="flex ml-[10px] pb-[60px]">
              <button
                className="w-[239px] rounded-[4px] h-[55px] bg-[#FFFFFF] text-[#044E97] font-semibold border border-blue-500"
                onClick={handleKeepCustomer}
              >
                Go back to customer
              </button>
            </div>
          </div>
        </div>
        {showSuccessSidebar && (
          <SidebarDrawer title="" show={true} position="left"  onClose={closeSuccessSidebar}>
            <LeftNotificationPopup
              title="Customer Deleted"
              icon={<ProcessSuccessful />}
              position="left"
              showSuccessModal={true}
          
            />
          </SidebarDrawer>
        )}
      </>
    );
  };

export { CustomerDeletePrompt };
